import { Component, ContentChild, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormGroupDirective,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { FieldAutocomplete, FormField } from '@app/shared/models/field.interface';

@Component({
  selector: 'vfs-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputComponent)
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class InputComponent implements ControlValueAccessor {
  @Input() field: FormField;
  @Input() readonly: boolean;
  @Input() type = 'text';
  @Input() maxLength = 255;
  @Input() width = '220px';
  @Input() error: string;
  @Input() autocomplete: FieldAutocomplete = FieldAutocomplete.OFF;
  @Input() autofocus = false;
  // No Form
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() hint?: string;
  @Input() formControl: FormControl;
  @Input() required: boolean = false;
  @Input() info: boolean = false;
  @Input() tooltip?: string;
  @Input() disabled: boolean;

  @Output() change = new EventEmitter();

  @ContentChild(MatAutocomplete) auto: MatAutocomplete;

  value: any;
  viewPassword = false;

  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
